import { injectIntl } from 'react-intl';

import SectionHeader from './section-header';

export default injectIntl(SectionHeader);
